(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cabana-file-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cabana-file-gallery')) {
  customElements.define('cabana-file-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const select = event.target.closest('[data-gallery-select]');
        if (select) {
          this.querySelectorAll('[data-gallery-image]').forEach(panel => { panel.hidden = panel.dataset.galleryImage !== select.dataset.gallerySelect; });
          this.querySelectorAll('[data-gallery-select]').forEach(button => { button.setAttribute('aria-pressed', String(button === select)); });
        }
        const panel = event.target.closest('[data-gallery-image]');
        if (panel) {
          const source = panel.querySelector('img');
          const zoom = dialog.querySelector('img');
          zoom.src = source.src;
          zoom.alt = source.alt;
          zoom.width = source.naturalWidth;
          zoom.height = source.naturalHeight;
          dialog.showModal();
        }
        if (event.target.closest('[data-gallery-close]')) dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cabana-footer-video"] && !Shopify.designMode) return;
  try {
    const footerVideos = document.querySelectorAll('.cabana-footer__video');
  const footerVideoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { rootMargin: '200px 0px' });

  footerVideos.forEach((video) => footerVideoObserver.observe(video));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cabana-product-signals"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cabana-fabrics]').forEach((container) => {
    if (container.dataset.cabanaFabricsReady === 'true') return;
    container.dataset.cabanaFabricsReady = 'true';

    const selection = container.querySelector('[data-cabana-fabric-selection]');
    const requestLink = container.querySelector('[data-cabana-fabric-link]');

    container.querySelectorAll('[data-cabana-fabric-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const fabric = input.value;
        const productTitle = container.dataset.productTitle;
        const params = new URLSearchParams({ product: productTitle, fabric });
        selection.textContent = `Selected: ${fabric}`;
        requestLink.href = `/pages/custom-orders?${params.toString()}`;
        requestLink.removeAttribute('aria-disabled');
      });
    });

    requestLink.addEventListener('click', (event) => {
      if (requestLink.getAttribute('aria-disabled') === 'true') event.preventDefault();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
